module.exports = __webpack_public_path__ + "6306d904854d97d5ea82c35263921d1a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-3.png
// module id = 2642
// module chunks = 0